import Swal from "sweetalert2"
import { Tooltip as ReactTooltip } from "react-tooltip";
import { lifecycleSuggestions } from "../../utility/lifeCycleSuggestions"

const SocialLeaderboardTrend = ({ trend, setSearchParams, searchParams, trendsData, page, index, setSelectedTagValue, userLoggedIn, bgColor }) => {

  return <div key={`${trend._id.tag}_${trend._id.value}`} className="flex h-28 my-1 overflow-x-hidden">
    <div className="z-[90]">

      <ReactTooltip
        id={`breakdown-${trend.tagFirst.tag}-${trend.tagFirst.value}` || `breakdown-${index}`}

      >
        <span className="text-[11px]">Breakdown {trend.tagFirst.value != '#N/A' ? trend.tagFirst.value : 'No Specific'}({trend.tagFirst.tag})</span>
      </ReactTooltip>
      <ReactTooltip
        id={`lifecycle-${trend.tagFirst.tag}-${trend.tagFirst.value}` || `${index}`}
        place="bottom"
        className="w-60"

      >
        <div className="py-1">
          <div className="">Suggestion : {lifecycleSuggestions[trend.lifecycle]}</div>
        </div>
        <div className="py-1 text-[11px]">
          <div className="">Past 7 day timeframe: {trend.is7dayTrend ? 'Above Thershold' : 'Below Thershold'}</div>
          <div className="">Past 15 day timeframe: {trend.is15dayTrend ? 'Above Thershold' : 'Below Thershold'}</div>
          <div className="">Past 30 day timeframe: {trend.is30dayTrend ? 'Above Thershold' : 'Below Thershold'}</div>
          <div className="">Past 60 day timeframe: {trend.is60dayTrend ? 'Above Thershold' : 'Below Thershold'}</div>
        </div>
      </ReactTooltip>
    </div>
    <div className="shrink-0 w-36 lg:w-40 h-full relative z-0">
      <div className={`w-full h-full overflow-hidden hover:z-40 hover:h-auto hover:absolute ${bgColor}`}>
        <h3 className="font-semibold hover:text-blue-500 text-blue-600 " data-tooltip-id={`breakdown-${trend.tagFirst.tag}-${trend.tagFirst.value}` || `breakdown-${index}`} onClick={() => {
          Swal.fire({ title: `Browsing different ways to do ${searchParams.get('gender')} > ${searchParams.get('category')} > ${trend.tagFirst.tag} > ${trend.tagFirst.value}.` })
          setSearchParams(prev => {
            prev.set('tag', trendsData.tag)
            prev.set('value', trend.tagFirst.value)
            return prev
          })
        }}>{index + 1 + (page - 1) * 5}. {trend.tagFirst.value != '#N/A' ? trend.tagFirst.value : 'No Specific'}</h3>
        {userLoggedIn && userLoggedIn.curator ? <p className="text-[11px] font-semibold"><span>Rate Of Growth:</span> {trend.rateOfGrowth != 0 ? parseInt(trend.rateOfGrowth * 1000) / 10 : '0'}<span>%</span>{trend.rogState ? <span>({trend.rogState})</span> : null}</p> : null}
        <p className="text-[11px]">Depth : {parseInt(trend.depth * 1000) / 10}%{trend.DepthState ? <span>({trend.DepthState})</span> : null}</p>
        {false ? <p className="text-[11px]" data-tooltip-id={`lifecycle-${trend.tagFirst.tag}-${trend.tagFirst.value}` || `${index}`} hidden={searchParams.get('gender') == 'Male'}> Lifecycle : {trend.lifecycle}        </p> : null}

      </div>
    </div>
    <div className="h-full px-1">
      <div className="flex h-full overflow-x-hidden " onClick={() => setSelectedTagValue({ tag: trend.tagFirst.tag, value: trend.tagFirst.value, trendType: 'social' })}>
        {
          trend.images ? trend.images.slice(0, 2).map(image => <img src={image.imageUrl} className="h-full w-auto ml-1 min-w-14" />) : null
        }
      </div>
    </div>
  </div>
}

export default SocialLeaderboardTrend
